import graphqlClient from "@/GQLClient";
import {
  GetPictogramsDocument,
  SavePictogramDocument,
  type PictogramInput,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const getAll = async () => {
  const response = await graphqlClient.query({
    query: GetPictogramsDocument,
  });

  if (response.data.pictograms) {
    return response.data.pictograms;
  }

  throw new SentryGraphQLError();
};

const save = async (pictogram: PictogramInput) => {
  const response = await graphqlClient.mutate({
    mutation: SavePictogramDocument,
    variables: {
      pictogram,
    },
  });

  if (response.data?.resource?.savePictogram?.success) {
    return response.data.resource.savePictogram;
  }

  throw new SentryGraphQLError();
};

export default {
  getAll,
  save,
};
